import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { Button } from './ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';
import { SparklesIcon } from './icons';

// A persistent "Upgrade" entry pinned at the bottom of the sidebar — the
// conventional always-reachable upgrade path, complementing the in-context limit
// dialog (UpgradePrompt) that only fires when a specific cap is hit. Shown ONLY to
// users on the default Free plan (hidden the moment they're on a paid plan), so it
// reads as an upsell, not noise. One click to /plans (which itself degrades to an
// honest "coming soon" when self-serve checkout isn't configured).
export default function UpgradeCta({ collapsed }: { collapsed: boolean }) {
  // null = unknown (still loading, or the read failed → render nothing); otherwise
  // the owner's current plan id. 'free' is the default plan (CHANGE_01 plan model).
  const [plan, setPlan] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    api
      .getSubscription()
      .then((sub) => {
        if (alive) setPlan(sub.plan);
      })
      .catch(() => {
        // Never break the shell over a billing read — just don't show the upsell.
      });
    return () => {
      alive = false;
    };
  }, []);

  if (plan !== 'free') return null;

  return (
    <div className="border-t border-border p-2">
      {collapsed ? (
        <Tooltip>
          <TooltipTrigger asChild>
            <Button size="icon" className="h-9 w-9" asChild>
              <Link to="/plans" aria-label="Upgrade plan">
                <SparklesIcon />
              </Link>
            </Button>
          </TooltipTrigger>
          <TooltipContent side="right">Upgrade plan</TooltipContent>
        </Tooltip>
      ) : (
        <Button className="w-full justify-start gap-2" asChild>
          <Link to="/plans">
            <SparklesIcon />
            Upgrade
          </Link>
        </Button>
      )}
    </div>
  );
}
